export class AdminReport {
  from_date: string;
  to_date: string;
  mode: string;
  biller: string;
  trxStatus: string;
  transactionId: string;
  bankTransactionId: string;
  serviceProvider: string;
  accountNumber: string;
  receiptNumber: string;
  billNumber: string;
  page_size: number;
  page_index: number;
}

export class PgUnprocessedTransactionVM {
  fromDate: string;
  toDate: string;
  pageSize: number;
  pageIndex: number;
  transactionId: string;
  mobileNumber: string;
  orderId: string;
}

export class ChangeStatusModel {
  paymentId: string;
  bankReferenceId: string;
  merchantName: string;
  paymentMethod: string;
  bankName: string;
  receiptNumber: string;
  billNumber: string;
  transactionId: string;
  bankTransactionId: string;
  status: string;
  billerName: string;
}

export class PgUnprocessedTransactionDetail {
  customerEmail: string;
  customerId: string;
  customerMobileNumber: string;
  customerName: string;
  merchantName: string;
  orderDetails: string;
  orderId: string;
  requestTime: string;
  transactionAmount: string;
  transactionCurrency: string;
  transactionId: string;
  actualAmount: string;
  serviceCharge: string;
  totalAmount: string;
  discountAmount: string;
  ekpayCharge: string;
  paymentMethod: string;
  bankName: string;
}

export class PgUnprocessedTransactionData {
  reason: string;
  response: string;
  pageSize: number;
  pageIndex: number;
  totalRecords: number;
  details: PgUnprocessedTransactionDetail[];

  constructor() {
    this.details = [];
  }
}

export class AdminTrxnsReport {
  reason: string;
  response: string;
  details: Detail[];
}

export class Detail {
  biller_name: string;
  payment_id: string;
  bill_accno: string;
  bill_last_paid_date?: Date;
  bill_mobile_no: string;
  bill_no: string;
  bill_period: string;
  bill_xchange_code: string;
  cust_mobile: string;
  cust_name: string;
  insert_tms: string;
  payee_mode: string;
  pi_bill_amount: number;
  pi_charges: number;
  discount_amount: number;
  discount_promo_amount: number;
  pi_ekpay_charges: number;
  pi_rev_stamp_fee: number;
  pi_vat_charges: number;
  receipt_no: string;
  selected_pi_name: string;
  selected_pi_type: string;
  service_name: string;
  service_provider: string;
  total_paid_amount: number;
  txns_status: string;
  user_id: string;
  merchant_txns_id: string;
  bank_trx_id: string;

  bill_type: string;
  bill_meter_no: string;
  bill_loc_code: string;
  biller_trn_id: string;
  order_number: string;
  bill_late_fee: string;
  bill_sewer_amount: string;
  bill_fixed_amount: string;
  recharge_amount: string;
  energy_cost: string;
  rebate_amount: string;
  meter_rent: string;
  demand_charge: string;
  bill_vat: string;
  bill_rev_stamp: string;
}

export class AppActiveBillerResponse {
  reason: string;
  response: string;
  billers: ActiveBillers[];
}

export class ActiveBillers {
  biller_id: string;
  biller_name: string;
}





// WEBPACK FOOTER //
// ./src/app/report/admin-report/admin-report.ts